import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const isForYou = ['Sos esteticista y querés sistematizar tu trabajo', 'Querés subir precios pero necesitás el criterio para hacerlo bien', 'Querés dejar de depender del boca a boca para conseguir clientas', 'Buscás que tus clientas vuelvan más seguido y gasten más', 'Querés una base profesional: contratos, protocolos, documentación'];
const notForYou = ['Buscás una solución mágica sin implementar nada', 'No estás dispuesta a invertir tiempo en mejorar tu negocio'];
export function ForWhoSection() {
  return <section className="py-24 px-6 bg-brand-white" data-id="element-71">
      <div className="max-w-5xl mx-auto" data-id="element-72">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-73">
          {/* Is For You */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="bg-green-50 rounded-3xl p-8 md:p-10 border border-green-100" data-id="element-74">
            <h3 className="text-2xl font-serif font-bold text-green-800 mb-8 flex items-center gap-3" data-id="element-75">
              <Check className="w-6 h-6" strokeWidth={3} data-id="element-76" />
              Es para vos si...
            </h3>
            <ul className="space-y-5" data-id="element-77">
              {isForYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-78">
                  <Check className="w-5 h-5 text-green-600 shrink-0 mt-1" data-id="element-79" />
                  <span className="text-green-900/80 font-sans" data-id="element-80">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-red-50 rounded-3xl p-8 md:p-10 border border-red-100" data-id="element-81">
            <h3 className="text-2xl font-serif font-bold text-red-800 mb-8 flex items-center gap-3" data-id="element-82">
              <X className="w-6 h-6" strokeWidth={3} data-id="element-83" />
              No es para vos si...
            </h3>
            <ul className="space-y-5" data-id="element-84">
              {notForYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-85">
                  <X className="w-5 h-5 text-red-500 shrink-0 mt-1" data-id="element-86" />
                  <span className="text-red-900/80 font-sans" data-id="element-87">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}